'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDirective$002dId$0024 from "./presto.types$-Directive-Id$.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dId$0024 from "./presto.types$-Grouping-Id$.js";
import * as $j_presto$002etypes$0024$002dRestricted$002dDomain$002dId$0024 from "./presto.types$-Restricted-Domain-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_Groupings$$anon$3(outer) {
  this.aWd = null;
  this.aWb = null;
  this.aWc = false;
  this.aW9 = null;
  this.aWa = false;
  this.aWe = false;
  this.aWf = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.aWd = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_Groupings$$anon$3 as $c_Lpresto_Groupings$$anon$3 };
$p = $c_Lpresto_Groupings$$anon$3.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Groupings$$anon$3;
/** @constructor */
function $h_Lpresto_Groupings$$anon$3() {
}
export { $h_Lpresto_Groupings$$anon$3 as $h_Lpresto_Groupings$$anon$3 };
$h_Lpresto_Groupings$$anon$3.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.aWd;
});
$p.t = (function() {
  if ((!this.aWc)) {
    this.aWb = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("domain", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("selected", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.aWc = true;
  }
  return this.aWb;
});
$p.ae = (function() {
  if ((!this.aWa)) {
    this.aW9 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGrouping$002dId$0024.$m_Lpresto_types$GroupingId$().SO(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRestricted$002dDomain$002dId$0024.$m_Lpresto_types$RestrictedDomainId$().GJ(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$25($j_presto$002etypes$0024$002dDirective$002dId$0024.$m_Lpresto_types$DirectiveId$().adv()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.aWa = true;
  }
  return this.aW9;
});
$p.w = (function() {
  if ((!this.aWf)) {
    this.aWe = false;
    this.aWf = true;
  }
  return this.aWe;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_Groupings$$anon$3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Groupings$$anon$3, "presto.Groupings$$anon$3", ({
  Jp: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_Groupings$$anon$3 as $d_Lpresto_Groupings$$anon$3 };
//# sourceMappingURL=presto.-Groupings$$anon$3.js.map
